const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBirthdayHat8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450.523,
    height: "160mm",
    viewBox: "0 0 119.201 160",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M97.077 50.894c3.877-9.447-2.116-20.379-14.14-25.78 1.01 1.432 1.77 2.898 1.9 4.483-2.514-1.355-5.601-2.208-8.79-2.431 10.895 6.79 18.292 16.136 20.632 26.068.391-.622.13-1.686.398-2.34",
    style: {
      fill: "#ee3264",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.488 50.284c-3.878-9.447 2.117-20.379 14.14-25.78-1.01 1.432-1.768 2.897-1.898 4.483 2.511-1.355 5.602-2.208 8.787-2.431-10.893 6.79-18.291 16.136-20.63 26.068-.392-.622-.13-1.687-.399-2.34",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.021 49.594c-2.07-9.12-14.648-16.59-28.198-16.748 2.405 1.047 5.204 2.835 6.808 4.442-2.755-1.107-6.393-1.107-9.15-.002 5.942 1.484 11.94 2.988 17.261 5.326 5.321 2.335 9.983 5.608 12.069 9.678-.095-1.656 1.58-1.057 1.21-2.696",
    style: {
      fill: "#94de4b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.227 38.324c4.392-2.99 10.668-4.805 16.841-4.349-2.557.831-4.798 2.112-6.442 3.683 2.787.185 5.458 1.108 7.32 2.53-2.345-1.783-13.535 2.098-15.705 3.061-4.932 2.191-8.936 5.442-10.837 9.257-.046-4.997 3.665-10.672 8.823-14.182",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.113 167.969 96.178 49.003 35.912 167.404s1.69 16.535 62.058 17.09c51.456.474 57.143-16.525 57.143-16.525",
    style: {
      fill: "#add5be",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.895 175.95c0-2.527 2.77-4.577 6.184-4.577 3.418 0 6.184 2.05 6.184 4.577 0 2.53-2.766 4.58-6.184 4.58-3.415 0-6.184-2.05-6.184-4.58",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.26 159.995c0-2.432 2.617-4.402 5.844-4.402 3.228 0 5.845 1.97 5.845 4.402 0 2.434-2.617 4.404-5.845 4.404-3.227 0-5.845-1.97-5.845-4.404",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.624 144.041c0-2.335 2.465-4.228 5.504-4.228 3.041 0 5.507 1.893 5.507 4.228 0 2.336-2.466 4.229-5.507 4.229-3.04 0-5.504-1.893-5.504-4.229",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.988 128.086c0-2.24 2.313-4.056 5.165-4.056 2.854 0 5.168 1.816 5.168 4.056 0 2.239-2.314 4.053-5.168 4.053-2.852 0-5.165-1.814-5.165-4.053",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.352 112.13c0-2.143 2.161-3.88 4.826-3.88 2.667 0 4.83 1.737 4.83 3.88s-2.163 3.88-4.83 3.88c-2.665 0-4.826-1.737-4.826-3.88",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.716 96.174c0-2.047 2.01-3.705 4.487-3.705 2.48 0 4.487 1.658 4.487 3.705s-2.007 3.705-4.487 3.705c-2.478 0-4.487-1.658-4.487-3.705",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.08 80.218c0-1.95 1.858-3.532 4.147-3.532 2.293 0 4.149 1.581 4.149 3.532s-1.856 3.532-4.149 3.532c-2.29 0-4.147-1.58-4.147-3.532",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.445 63.652c0-1.855 1.705-3.356 3.807-3.356 2.106 0 3.81 1.501 3.81 3.356s-1.704 3.357-3.81 3.357c-2.102 0-3.807-1.502-3.807-3.357",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.983 165.636c1.017-2.297 3.35-3.847 5.211-3.465 1.861.382 2.545 2.554 1.528 4.849-1.018 2.297-3.351 3.847-5.212 3.465-1.86-.383-2.545-2.554-1.527-4.849",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.601 151.187c.979-2.208 3.198-3.705 4.957-3.342 1.759.36 2.391 2.443 1.412 4.651-.978 2.208-3.198 3.705-4.956 3.345-1.76-.363-2.391-2.446-1.413-4.654",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.22 136.74c.94-2.122 3.045-3.566 4.701-3.225 1.657.342 2.238 2.336 1.298 4.457-.94 2.122-3.045 3.563-4.701 3.225-1.657-.342-2.238-2.338-1.298-4.457",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.838 122.29c.902-2.032 2.892-3.42 4.447-3.101 1.554.32 2.084 2.227 1.183 4.26-.901 2.032-2.892 3.42-4.447 3.101-1.554-.32-2.084-2.227-1.183-4.26",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.457 107.843c.862-1.946 2.739-3.282 4.191-2.984 1.452.298 1.93 2.12 1.068 4.066-.862 1.943-2.738 3.28-4.19 2.981-1.453-.298-1.931-2.119-1.069-4.063",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.076 93.394c.823-1.857 2.585-3.14 3.936-2.861 1.35.276 1.777 2.008.953 3.865-.824 1.86-2.586 3.14-3.936 2.864-1.35-.278-1.777-2.01-.953-3.868",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.694 78.945c.785-1.77 2.433-2.999 3.681-2.742 1.248.257 1.624 1.9.839 3.672-.785 1.77-2.433 2.998-3.681 2.741-1.248-.255-1.624-1.898-.839-3.671",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.187 164.68c.605-2.35 2.931-4.034 5.196-3.763 2.264.272 3.61 2.393 3.004 4.743-.605 2.347-2.93 4.032-5.195 3.763-2.265-.272-3.61-2.393-3.005-4.743",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.413 149.3c.58-2.255 2.78-3.877 4.914-3.623 2.132.255 3.39 2.29 2.81 4.546-.582 2.256-2.782 3.878-4.915 3.623-2.133-.254-3.39-2.29-2.81-4.545",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.638 133.921c.557-2.164 2.63-3.724 4.633-3.483 2 .238 3.172 2.186 2.615 4.348-.558 2.163-2.632 3.722-4.633 3.484-2.002-.24-3.172-2.186-2.615-4.349",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.863 118.54c.533-2.069 2.481-3.566 4.351-3.342 1.87.223 2.954 2.083 2.42 4.152-.532 2.068-2.48 3.565-4.35 3.342-1.87-.224-2.954-2.081-2.42-4.152",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.088 103.16c.51-1.977 2.332-3.409 4.07-3.202 1.738.21 2.735 1.98 2.226 3.955-.51 1.977-2.331 3.412-4.07 3.202-1.738-.206-2.735-1.977-2.226-3.954",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.314 87.782c.485-1.884 2.181-3.256 3.788-3.064 1.607.192 2.516 1.874 2.031 3.758-.485 1.884-2.181 3.256-3.788 3.063-1.607-.192-2.516-1.874-2.031-3.757",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.54 72.402c.46-1.792 2.03-3.099 3.506-2.924 1.475.178 2.297 1.771 1.836 3.561-.461 1.793-2.031 3.1-3.507 2.924-1.475-.175-2.297-1.77-1.836-3.56",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.023 176.157c-2.396.286-3.828 2.496-3.2 4.94.177.68.498 1.305.917 1.85 2.886-.43 5.51-.93 7.896-1.485a4.5 4.5 0 0 0-.135-1.403c-.631-2.441-3.083-4.188-5.478-3.902M67.138 182.325c.216-.385.389-.796.5-1.228.63-2.444-.803-4.654-3.199-4.94-2.396-.286-4.848 1.46-5.477 3.902a4.658 4.658 0 0 0-.12.706c2.486.567 5.242 1.091 8.296 1.56",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.275 164.68c-.607-2.35-2.931-4.034-5.196-3.763-2.265.272-3.61 2.393-3.006 4.743.607 2.347 2.932 4.032 5.197 3.763 2.264-.272 3.608-2.393 3.005-4.743",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.049 149.3c-.582-2.255-2.78-3.877-4.914-3.623-2.131.255-3.39 2.29-2.808 4.546.578 2.256 2.78 3.878 4.914 3.623 2.13-.254 3.39-2.29 2.808-4.545",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.823 133.921c-.558-2.164-2.629-3.724-4.632-3.483-2 .238-3.172 2.186-2.614 4.348.557 2.163 2.631 3.722 4.632 3.484 2-.24 3.171-2.186 2.614-4.349",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6 118.54c-.533-2.069-2.484-3.566-4.353-3.342-1.87.223-2.953 2.083-2.42 4.152.532 2.068 2.483 3.565 4.353 3.342 1.87-.224 2.953-2.081 2.42-4.152",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.374 103.16c-.508-1.977-2.332-3.409-4.071-3.202-1.736.21-2.734 1.98-2.226 3.955.511 1.977 2.331 3.412 4.07 3.202 1.74-.206 2.735-1.977 2.227-3.954",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.147 87.782c-.483-1.884-2.18-3.256-3.788-3.064-1.606.192-2.516 1.874-2.029 3.758.483 1.884 2.18 3.256 3.789 3.063 1.605-.192 2.515-1.874 2.028-3.757",
    style: {
      fill: "#feb1b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.269 71.487c-.462-1.792-2.032-3.1-3.507-2.924-1.478.175-2.3 1.77-1.838 3.56.462 1.793 2.032 3.1 3.507 2.925 1.474-.178 2.296-1.771 1.838-3.56",
    style: {
      fill: "#f68121",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47 165.83c-1.03-2.318-3.75-3.812-6.078-3.334-2.329.48-3.383 2.748-2.357 5.07 1.03 2.32 3.75 3.812 6.082 3.334 2.328-.478 3.38-2.748 2.353-5.07",
    style: {
      fill: "#35b1f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.729 151.237c-.988-2.232-3.574-3.676-5.775-3.224-2.202.454-3.183 2.63-2.195 4.863.992 2.232 3.577 3.673 5.779 3.222 2.198-.452 3.182-2.629 2.19-4.86",
    style: {
      fill: "#ffda3e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.99 136.641c-.949-2.143-3.4-3.536-5.475-3.109-2.07.426-2.984 2.509-2.032 4.652.95 2.145 3.401 3.536 5.475 3.111 2.071-.428 2.981-2.51 2.032-4.654",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.249 122.045c-.91-2.054-3.225-3.397-5.172-2.996-1.944.4-2.783 2.388-1.873 4.445.914 2.054 3.228 3.397 5.172 2.999 1.947-.402 2.787-2.391 1.873-4.448",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51 107.45c-.87-1.966-3.05-3.259-4.868-2.884-1.82.373-2.585 2.27-1.714 4.239.871 1.965 3.052 3.257 4.872 2.883 1.817-.373 2.582-2.27 1.71-4.239",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.77 92.856c-.833-1.879-2.876-3.121-4.566-2.773-1.69.346-2.384 2.15-1.552 4.03.833 1.878 2.879 3.12 4.565 2.772 1.69-.346 2.385-2.15 1.552-4.029",
    style: {
      fill: "#9e7cdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.031 78.26c-.794-1.79-2.702-2.982-4.265-2.66-1.563.32-2.184 2.033-1.39 3.823.794 1.79 2.702 2.982 4.262 2.66 1.563-.322 2.187-2.033 1.393-3.823",
    style: {
      fill: "#ff3636",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.186 183.437c-14.082-1.353-23.246-3.818-29.205-6.415L85.19 91.068c.322.253.712.418 1.155.471.1.012.202.017.303.017.436 0 .872-.108 1.284-.305l-1.435 11.256c-.14-1.35-1.03-2.393-2.339-2.549a3.188 3.188 0 0 0-.338-.02c-1.63 0-3.255 1.375-3.732 3.223-.509 1.977.488 3.748 2.226 3.955.113.014.225.021.338.021 1.52 0 3.035-1.194 3.62-2.854l-10.086 79.154m-12.265-7.311c-2.222 0-4.376 1.667-4.96 3.933a4.658 4.658 0 0 0-.12.706 117.56 117.56 0 0 0 8.297 1.56c.216-.385.389-.796.5-1.228.63-2.444-.803-4.654-3.199-4.94a4.18 4.18 0 0 0-.518-.031m3.98-15.238c-2.104 0-4.152 1.61-4.714 3.792-.605 2.35.74 4.471 3.005 4.742.16.02.32.03.481.03 2.104 0 4.152-1.61 4.714-3.792.605-2.35-.74-4.471-3.004-4.743a4.061 4.061 0 0 0-.482-.029m3.98-15.237c-1.985 0-3.928 1.55-4.468 3.65-.582 2.256.676 4.29 2.81 4.545.147.017.296.027.444.027 1.986 0 3.929-1.552 4.47-3.65.58-2.256-.678-4.29-2.81-4.546a3.952 3.952 0 0 0-.446-.026m3.98-15.237c-1.867 0-3.704 1.492-4.223 3.507-.557 2.163.613 4.109 2.615 4.35.136.014.272.023.409.023 1.868 0 3.704-1.492 4.224-3.508.557-2.162-.614-4.11-2.615-4.348a3.337 3.337 0 0 0-.41-.024m3.98-15.238c-1.749 0-3.48 1.432-3.978 3.364-.533 2.07.55 3.928 2.42 4.152.125.016.25.024.374.024 1.749 0 3.48-1.435 3.978-3.366.533-2.07-.55-3.929-2.42-4.152a3.24 3.24 0 0 0-.374-.022m8.901-30.29a2.313 2.313 0 0 0-.64-.168c-.029-.002-.057-.007-.086-.01l1.05-2.359-.324 2.537",
    style: {
      fill: "#d7eadf",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.673 169.451c-.16 0-.32-.01-.481-.028-2.265-.272-3.61-2.393-3.005-4.743.562-2.182 2.61-3.792 4.714-3.792.16 0 .321.01.482.03 2.264.27 3.61 2.392 3.004 4.742-.562 2.182-2.61 3.791-4.714 3.791",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.667 153.873c-.148 0-.297-.01-.445-.027-2.133-.254-3.39-2.29-2.81-4.545.541-2.1 2.484-3.65 4.47-3.65.148 0 .296.01.445.026 2.132.255 3.39 2.29 2.81 4.546-.541 2.098-2.484 3.65-4.47 3.65",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.662 138.294c-.137 0-.273-.01-.409-.024-2.002-.24-3.172-2.186-2.615-4.348.52-2.016 2.356-3.508 4.224-3.508.136 0 .272.007.409.024 2 .238 3.172 2.186 2.615 4.349-.52 2.015-2.356 3.507-4.224 3.507",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.657 122.716c-.125 0-.25-.007-.373-.024-1.87-.224-2.954-2.081-2.42-4.152.497-1.932 2.228-3.364 3.977-3.364.125 0 .25.007.373.022 1.87.223 2.954 2.083 2.42 4.152-.497 1.931-2.228 3.366-3.977 3.366",
    style: {
      fill: "#ff9c9c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.652 107.137c-.113 0-.225-.007-.338-.021-1.738-.207-2.735-1.978-2.226-3.955.477-1.848 2.102-3.222 3.732-3.222.113 0 .225.007.338.02 1.31.155 2.198 1.198 2.34 2.548l-.227 1.776c-.584 1.66-2.099 2.854-3.619 2.854",
    style: {
      fill: "#ffeda0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.648 91.556c-.101 0-.202-.005-.303-.017a2.293 2.293 0 0 1-1.155-.47l2.826-6.36c.029.002.057.007.086.01.228.026.442.083.64.167l-.81 6.365a2.977 2.977 0 0 1-1.284.305",
    style: {
      fill: "#fbc192",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.138 182.325c-3.054-.469-5.81-.993-8.297-1.56a4.67 4.67 0 0 1 .12-.706c.584-2.266 2.738-3.933 4.96-3.933.172 0 .345.01.518.031 2.396.286 3.828 2.496 3.2 4.94a5.094 5.094 0 0 1-.501 1.228",
    style: {
      fill: "#ffd9d9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.81 181.652c21.315-4.73 24.303-13.683 24.303-13.683s-2.988 8.952-24.303 13.683",
    style: {
      fill: "#cdcfd1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.062 184.504a296.7 296.7 0 0 1-9.992-.183 149.243 149.243 0 0 0 2.66-4.522c.965.461 2.115.73 3.35.73 3.417 0 6.183-2.049 6.183-4.579 0-2.26-2.215-4.137-5.126-4.51 7.656-15.547 13.473-33.1 16.659-49.5.807-.774 1.153-2.04.804-3.4a7.015 7.015 0 0 0-.117-.378c.477-2.772.872-5.506 1.182-8.183.907 1.086 2.237 1.773 3.486 1.773.218 0 .437-.021.649-.065 1.817-.372 2.582-2.27 1.71-4.238-.772-1.737-2.564-2.948-4.222-2.948-.219 0-.437.022-.646.065a2.667 2.667 0 0 0-.462.135c.413-5.373.459-10.457.103-15.113l38.83 78.38s-2.988 8.953-24.303 13.684c-7.652 1.698-17.664 2.854-30.748 2.851m26.48-8.377c-.173 0-.346.01-.52.03-2.395.287-3.827 2.497-3.199 4.94.177.68.498 1.305.917 1.85 2.886-.43 5.51-.93 7.896-1.484a4.5 4.5 0 0 0-.135-1.403c-.585-2.266-2.737-3.933-4.96-3.933m16.743-13.72c-.3 0-.6.03-.892.09-2.329.48-3.383 2.748-2.357 5.07.9 2.027 3.094 3.423 5.186 3.423.3 0 .6-.029.896-.09 2.328-.477 3.38-2.748 2.353-5.069-.9-2.027-3.09-3.423-5.186-3.423m-20.722-1.519c-.162 0-.32.01-.483.029-2.265.272-3.61 2.393-3.006 4.743.565 2.181 2.61 3.791 4.717 3.791.159 0 .32-.01.48-.029 2.264-.271 3.608-2.393 3.005-4.742-.56-2.182-2.61-3.792-4.713-3.792m14.224-12.957c-.282 0-.56.026-.832.082-2.202.454-3.183 2.63-2.195 4.863.868 1.955 2.96 3.303 4.946 3.303.279 0 .558-.026.833-.082 2.198-.451 3.182-2.628 2.19-4.86-.864-1.956-2.96-3.306-4.942-3.306m-18.207-2.28c-.148 0-.296.01-.444.026-2.131.255-3.39 2.29-2.808 4.546.54 2.097 2.483 3.65 4.466 3.65.151 0 .3-.01.448-.027 2.13-.255 3.39-2.29 2.808-4.546-.54-2.1-2.484-3.65-4.47-3.65m11.705-12.195c-.257 0-.515.024-.769.077-2.07.425-2.984 2.508-2.032 4.651.833 1.884 2.826 3.189 4.703 3.189.26 0 .518-.027.772-.077 2.071-.428 2.981-2.51 2.032-4.654-.836-1.884-2.829-3.186-4.706-3.186m-15.684-3.042c-.138 0-.272.007-.41.024-2 .238-3.17 2.187-2.613 4.35.518 2.015 2.356 3.507 4.222 3.507.138 0 .276-.01.41-.024 2-.24 3.171-2.186 2.614-4.349-.519-2.016-2.353-3.508-4.223-3.508m9.186-11.436c-.24 0-.476.024-.709.072-1.944.399-2.783 2.388-1.873 4.445.804 1.811 2.699 3.068 4.466 3.068.24 0 .476-.024.706-.07 1.947-.4 2.787-2.39 1.873-4.447-.8-1.811-2.695-3.068-4.463-3.068",
    style: {
      fill: "#8eae9f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.08 180.53c-1.235 0-2.385-.27-3.35-.73 1.528-2.706 3-5.498 4.407-8.36 2.91.373 5.126 2.25 5.126 4.51 0 2.53-2.766 4.58-6.184 4.58",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74 182.947a5.167 5.167 0 0 1-.917-1.85c-.628-2.444.805-4.654 3.2-4.94.173-.022.346-.031.518-.031 2.223 0 4.375 1.667 4.96 3.933.124.48.163.954.135 1.403a99.733 99.733 0 0 1-7.896 1.485",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.79 169.451c-2.106 0-4.152-1.61-4.717-3.79-.603-2.35.741-4.472 3.006-4.744a4.08 4.08 0 0 1 .483-.029c2.103 0 4.152 1.61 4.713 3.792.603 2.35-.74 4.471-3.005 4.743-.16.019-.321.028-.48.028",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.793 153.873c-1.983 0-3.927-1.552-4.466-3.65-.582-2.256.677-4.29 2.808-4.546.148-.016.296-.026.444-.026 1.986 0 3.93 1.55 4.47 3.65.582 2.256-.677 4.29-2.808 4.545a3.958 3.958 0 0 1-.448.027",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.8 138.294c-1.867 0-3.705-1.492-4.223-3.508-.558-2.162.613-4.11 2.614-4.348.137-.017.271-.024.409-.024 1.87 0 3.704 1.492 4.223 3.508.557 2.162-.614 4.108-2.614 4.348a3.844 3.844 0 0 1-.41.024",
    style: {
      fill: "#c66e21",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.796 121.94c.243-1.267.472-2.526.687-3.777.043.125.082.25.117.377.35 1.36.004 2.626-.804 3.4",
    style: {
      fill: "#cc9396",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.221 170.99c-2.092 0-4.286-1.397-5.186-3.425-1.026-2.32.028-4.589 2.357-5.07.293-.06.592-.088.892-.088 2.096 0 4.287 1.396 5.186 3.424 1.027 2.32-.025 4.591-2.353 5.07-.296.06-.596.088-.896.088",
    style: {
      fill: "#3293c5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.705 156.18c-1.986 0-4.078-1.349-4.946-3.304-.987-2.232-.007-4.41 2.195-4.863.271-.055.55-.082.832-.082 1.983 0 4.078 1.35 4.943 3.306.99 2.232.007 4.409-2.191 4.86a4.23 4.23 0 0 1-.833.082",
    style: {
      fill: "#cdb23d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.186 141.372c-1.877 0-3.87-1.305-4.703-3.188-.952-2.143-.038-4.226 2.032-4.652.254-.053.512-.077.77-.077 1.876 0 3.87 1.303 4.705 3.186.95 2.143.04 4.226-2.032 4.654-.254.05-.511.077-.772.077",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67 126.562c-1.767 0-3.662-1.256-4.466-3.068-.91-2.057-.07-4.046 1.873-4.445.233-.048.47-.072.71-.072 1.767 0 3.661 1.257 4.462 3.068.914 2.057.074 4.046-1.873 4.448-.23.045-.466.07-.706.07",
    style: {
      fill: "#836ab5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15 111.753c-1.248 0-2.578-.688-3.485-1.774.208-1.785.381-3.548.515-5.278.145-.058.297-.101.463-.135.208-.043.426-.065.645-.065 1.658 0 3.45 1.211 4.223 2.948.871 1.968.106 3.866-1.711 4.239-.212.043-.43.064-.65.064",
    style: {
      fill: "#cd3436",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0291134
    },
    transform: "translate(-35.912 -24.504)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthdayHat8);
export default __webpack_public_path__ + "static/media/birthday_hat_8.d6475d76f315fb00eefbd6cc92749f1d.svg";
export { ForwardRef as ReactComponent };